import API from '@/api'
export const moduleName = 'carManager'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_JOIN_TO_CAR_MANAGER: 'ACTION_JOIN_TO_CAR_MANAGER',
  ACTION_LOAD_CARS: 'ACTION_LOAD_CARS',
  ACTION_LOAD_MARKETPLACE_VEHICLES: 'ACTION_LOAD_MARKETPLACE_VEHICLES',
  ACTION_LOAD_DRAFT_CARS: 'ACTION_LOAD_DRAFT_CARS',
  ACTION_LOAD_CAR_BY_ID: 'ACTION_LOAD_CAR_BY_ID',
  ACTION_TEST_MODE_CAR: 'ACTION_TEST_MODE_CAR',
  ACTION_VERIFY_CAR: 'ACTION_VERIFY_CAR',
  ACTION_SITE_CONFIG: 'ACTION_SITE_CONFIG',
  ACTION_GET_SITE_CONFIG: 'ACTION_GET_SITE_CONFIG',
}

export const getterTypes = {
  GETTER_CARS: 'GETTER_CARS',
  GETTER_DRAFT_CARS: 'GETTER_DRAFT_CARS',
  GETTER_CAR: 'GETTER_CAR',
  GETTER_DRAFT_CARS_COUNT: 'GETTER_DRAFT_CARS_COUNT',
  GETTER_CARS_COUNT: 'GETTER_CARS_COUNT',
  GETTER_PAGE_RELOAD: 'GETTER_PAGE_RELOAD',
}

export const mutationTypes = {
  MUTATION_SET_DRAFT_CARS: 'MUTATION_SET_DRAFT_CARS',
  MUTATION_SET_CARS: 'MUTATION_SET_CARS',
  MUTATION_SET_CAR: 'MUTATION_SET_CAR',
  MUTATION_UPDATE_CAR: 'MUTATION_UPDATE_CAR',
  MUTATION_ADD_CAR: 'MUTATION_ADD_CAR'
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    cars: [],
    draftCars: [],
    draftCarsCount: 0,
    carsCount: 0,
    isPageReload: false,
    currentCar: null
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit }) {
      const onUpdateCar = ({ value }) => {
        commit(mutationTypes.MUTATION_UPDATE_CAR, value.car)
      }

      const onNewCarAdded = ({ value }) => {
        commit(mutationTypes.MUTATION_ADD_CAR, value)
      }

      API.carManager.wsListeners[API.carManager.wsEvents.CAR_MANAGER_UPDATE_CAR](onUpdateCar)
      API.carManager.wsListeners[API.carManager.wsEvents.CAR_MANAGER_NEW_CAR](onNewCarAdded)

    },

    [actionTypes.ACTION_JOIN_TO_CAR_MANAGER]() {
      API.carManager.wsActions.ACTION_JOIN_TO_CAR_MANAGER()
    },
    
    async [actionTypes.ACTION_LOAD_DRAFT_CARS] ({ commit }, payload) {
      const result = await API.carManager.loadDraftCars(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_CARS, [cars, carsCount])
    },
    async [actionTypes.ACTION_LOAD_MARKETPLACE_VEHICLES] ({ commit }, payload) {
      const result = await API.carManager.loadMarketplaceVehicles(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_CARS, [cars, carsCount])
    },
    async [actionTypes.ACTION_LOAD_CARS] ({ commit }, payload) {
      const result = await API.carManager.loadCars(payload)
      const { cars, carsCount } = result.data
      commit(mutationTypes.MUTATION_SET_CARS, [cars, carsCount])
    },

    async [actionTypes.ACTION_LOAD_CAR_BY_ID] ({ commit }, payload) {
      const result = await API.carManager.loadCarBYId(payload)
      commit(mutationTypes.MUTATION_SET_CAR, result.data)
    },
    
    [actionTypes.ACTION_TEST_MODE_CAR]({}, payload) {
      API.carManager.wsActions.ACTION_TEST_MODE_CAR(payload)
    },
    [actionTypes.ACTION_VERIFY_CAR]({}, payload) {
      API.carManager.wsActions.ACTION_VERIFY_CAR(payload)
    },
    [actionTypes.ACTION_SITE_CONFIG]({}, payload) {
      API.carManager.wsActions.ACTION_SITE_CONFIG(payload)
    },
    async [actionTypes.ACTION_GET_SITE_CONFIG]({}, payload) {
      const result = await API.carManager.getSiteConfigByModule(payload)
    }
  },

  mutations: {
    [mutationTypes.MUTATION_SET_CAR](state, car) {
      state.currentCar = car
    },
    [mutationTypes.MUTATION_SET_DRAFT_CARS](state, [cars, carsCount]) {
      state.draftCars = cars
      state.draftCarsCount = carsCount
    },
    [mutationTypes.MUTATION_SET_CARS](state, [cars, carsCount]) {
      state.cars = cars
      state.carsCount = carsCount
    },
    [mutationTypes.MUTATION_UPDATE_CAR](state, car) {
      const carIndex = state.cars.findIndex(c => c.id === car.id)
      if (carIndex >= 0) {
        state.cars.splice(carIndex, 1, car)
      }
    },
    [mutationTypes.MUTATION_ADD_CAR](state, car) {
      state.cars.splice(0, 0, car)
    }
  },

  getters: {
    [getterTypes.GETTER_DRAFT_CARS]: (state) => state.draftCars,
    [getterTypes.GETTER_CARS]: (state) => state.cars,
    [getterTypes.GETTER_CAR]: (state) => state.currentCar,
    [getterTypes.GETTER_CARS_COUNT]: (state) => state.carsCount,
    [getterTypes.GETTER_DRAFT_CARS_COUNT]: (state) => state.draftCarsCount,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,
  }
}
